/**
 * `GENDER` is the same path the control form uses — `onboarding.module.ts` registers both components
 * on it and lets `onboardingProfileBreakdownGuard` pick. Only `NAME` and `AGE` are new paths.
 */
export const ONBOARDING_PROFILE_ROUTES = {
  GENDER: '/onboarding/gender',
  NAME: '/onboarding/name',
  AGE: '/onboarding/age',
} as const;

/** Where the profile flow hands off — the existing face/hair class selection page. */
export const ONBOARDING_CONCERN_ROUTE = '/onboarding/concern';

/** `onboarding-concern` forwards this to `/mainConcern` so its back button reaches home. */
export const ONBOARDING_CONCERN_QUERY_PARAMS = { redirectOnBack: '/home' } as const;
